import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const TopBanner = () => {
  return (
    <div className="banner w-100 py-2">
      <div className="container">
        <div className="row d-sm-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="col col-md-4 col-sm-12 text-center mb-md-0">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="banner-icon pe-2"
              size="1x"
            />
           Ankara
          </div>
          <div className="col col-md-4 col-sm-12 text-center mb-md-0">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="banner-icon pe-2"
              size="1x"
            />
             <a href="mailto:av.aliardagul@gmail.com?subject=Danışmanlık%20Talebi&body=Merhaba%20Avukat%20Ali%20Arda,%0A%0AAdım:%20[Adınızı%20Yazınız]%0A%0ATelefon%20Numaram:%20[Telefon%20Numaranızı%20Yazınız]%0A%0ABir%20danışmanlık%20talebim%20var.%0A%0ATeşekkür%20ederim."
   className="email-link">
   E-Posta Gönder
</a>
   

          </div>
          <div className="col col-md-4 col-sm-12 text-center">
            <FontAwesomeIcon
              icon={faPhone}
              className="banner-icon phone-icon pe-2"
              size="1x"
            />{" "}
           <a href="tel: +90 543 882 20 92 " style={{ textDecoration: 'none', color: 'blue' }}>
           +90 543 882 20 92
</a>


            
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
